/** Re-export the package types this slice consumes, for tidy single-line imports. */
export type { Booking, BookingStatus } from '@hostesa/api-client';
export type { StatusVariant } from '@hostesa/ui';

import { ApiError } from '@hostesa/api-client';

/** Coerce an `unknown` scalar (contract-gap nullable field) to a display string. */
export function asString(value: unknown): string | undefined {
  if (value === null || value === undefined) return undefined;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : undefined;
  }
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return undefined;
}

/** Whether an error is a 409 conflict (invalid booking-state on the backend). */
export function isConflict(err: unknown): boolean {
  return err instanceof ApiError && err.isConflict;
}
